// extracted by mini-css-extract-plugin
module.exports = {"paginator":"paginator_paginator__32dYl"};